/**
 * The English catalogue — the KEY set, and the fallback every other language falls back to.
 *
 * Imported statically and not globbed: the bundle is static, so a directory listing cannot be the registry
 * (§27.18). A namespace not named here does not exist, and `check:i18n` verifies that in both directions
 * rather than trusting this list to stay in step with the folder.
 */
import boot from './boot.ts';
import door from './door.ts';
import entry from './entry.ts';
import fields from './fields.ts';
import hud from './hud.ts';
import keys from './keys.ts';
import lobby from './lobby.ts';
import loadout from './loadout.ts';
import markers from './markers.ts';
import match from './match.ts';
import readout from './readout.ts';
import sanction from './sanction.ts';
import touch from './touch.ts';
import zone from './zone.ts';

export default { boot, door, entry, fields, hud, keys, lobby, loadout, markers, match, readout, sanction, touch, zone };
